import {translate} from './text';

const filters = {
    translate
}

export default filters